import App from './app.reducer'
import { combineReducers } from 'redux'

const rootReducer = combineReducers({
    App,
})

export default rootReducer